import React from "react";
import { Card } from "@mui/material";
import styles from "./card.module.scss";
import {
  FREE_SERIES,
  FREE_SERIES_V2,
  NEW_SERIES,
  TOP_SERIES,
} from "../../utils/constants";
import { handleConvertSecondsToMinutes } from "../../utils/utils";
import { handleCheckVideoDetails } from "../../utils/constants/videoDetails";
import Link from "next/link";
import ScreenReaderOnly from "../v3/components/Common/ScreenReaderOnly";

export default function CardComponent({
  type,
  cardData,
  cardRef,
  index,
  section_type,
}) {
  const goToSeries = () => {
    if (type === FREE_SERIES || type === FREE_SERIES_V2) {
      return `/video/${cardData?.series?.slug || cardData?.slug}${
        type === FREE_SERIES_V2 && `?type=free&muted=false`
      }`;
    } else {
      const redirect = handleCheckVideoDetails({ slug: cardData?.slug });
      return redirect
        ? `/details/${cardData?.slug}`
        : `/video/${cardData.slug}?muted=false`;
    }
  };

  return (
    <Link href={goToSeries()} passHref>
      <a href={goToSeries()} className="no-underline">
        <div>
          <div
            className={`${styles.card} ${
              type === NEW_SERIES && styles.newSeries_card
            } ${type !== TOP_SERIES && styles.all_series_not_top}`}
          >
            <Card
              className={styles.cardContent}
              style={{
                backgroundImage: `url(${
                  type !== FREE_SERIES
                    ? cardData?.image
                    : cardData?.series?.image
                })`,
              }}
            >
              {cardData?.is_locked && (
                <img
                  src={`/assets/Lock.svg`}
                  alt="lockIcon"
                  className="absolute z-10 text-white top-2 mx-auto !left-0 !right-0"
                />
              )}

              <div className={styles.title_icon_image}>
                <span className={styles.title}>
                  {type !== FREE_SERIES
                    ? cardData?.image_title
                    : cardData?.series?.image_title}
                </span>
                <span
                  className={styles.creatorname}
                  style={{
                    background:
                      type !== FREE_SERIES
                        ? cardData?.creator_color
                        : cardData?.series?.creator_color,
                  }}
                >
                  {type !== FREE_SERIES
                    ? cardData?.creator?.name
                    : cardData?.series?.creator?.name}
                </span>
              </div>

              {type == TOP_SERIES && (
                <h2
                  className={`${styles.number_topseries} ${
                    index == 9 && styles.number_ten_card
                  }`}
                  style={{ position: "absolute", zIndex: "99" }}
                >
                  {index + 1}
                </h2>
              )}

              {type === "top_10_series" && (
                <h2
                  className={`${styles.number_topseries} ${
                    index == 9 && styles.number_ten_card
                  }`}
                  style={{ position: "absolute", zIndex: "99" }}
                >
                  {index + 1}
                </h2>
              )}

              <img
                className={styles.cardImage}
                style={{ position: "absolute", top: "0" }}
                src={
                  type !== FREE_SERIES
                    ? cardData?.image
                    : cardData?.series?.image
                }
                alt={cardData?.display_title}
              />
              <span ref={cardRef}></span>
            </Card>

            {type === "top_10_series_v3" ||
            type === "new_series" ||
            type === "top_10_series" ||
            type === "free_series_v2" ? null : (
              <div className=" md:block w-[95%] mx-auto relative">
                <h6 className="text-[15px] text-white line-clamp-2 text-left mt-2 h-[39.5px] md:text-[15.5px]">
                  {cardData?.display_title}
                </h6>
                <div className="flex">
                  <h6 className="text-gray-400 text-[13px] font-normal flex gap-x-2 items-center">
                    {handleConvertSecondsToMinutes({
                      seconds: cardData?.duration_s,
                    })}{" "}
                    {cardData?.rating && <span>•</span>}
                    {cardData?.rating && <span>{cardData?.rating}</span>}
                    {cardData?.rating && (
                      <span className="text-[10px] -ml-1 text-yellow-500">
                        ★
                      </span>
                    )}
                  </h6>
                  <ScreenReaderOnly content={cardData?.description} />
                </div>
              </div>
            )}
          </div>
        </div>
      </a>
    </Link>
  );
}
